<template>
  <div v-if="roleForm" class="py-8">
    <RolePropertiesForm :form="roleForm" @on-save="saveRole" @on-delete="confirmDelete"/>
  </div>
</template>

<script>
import RolePropertiesForm from "@/Forms/Role/RolePropertiesForm.vue";
import {mapStores} from "pinia";
import {useRolesStore} from "@/stores/roles.js";

export default {
  name: "RolePropertiesView",
  components: {RolePropertiesForm},
  data() {
    return {
      roleForm: undefined,
    }
  },
  emits: [
    'on-save',
    'on-delete',
  ],
  computed: {
    ...mapStores(useRolesStore)
  },
  methods: {
    async saveRole() {
      try {
        const response = await this.roleForm.submit();
        this.$toast.add({
          severity: 'success',
          summary: this.$t('common.complete'),
          detail: this.$t('pages.admin.users.roles.role.properties.role_properties_view.role_saved'),
          life: 3000
        });
        this.$emit('on-save');
        this.$router.replace({params: {...this.$route.params, role: response.data.id}});
      } catch (error) {
        //
      }
    },
    confirmDelete() {
      this.$confirm.require({
        group: 'delete',
        message: this.$t('pages.admin.users.roles.role.properties.role_properties_view.are_you_sure_you_want_to_delete_this_role'),
        header: this.$t('pages.admin.users.roles.role.properties.role_properties_view.delete_role'),
        accept: () => {
          this.deleteRole();
        },
        reject: () => {
          this.$toast.add({
            severity: 'info',
            summary: this.$t('common.cancelled'),
            detail: this.$t('pages.admin.users.roles.role.properties.role_properties_view.role_was_not_deleted'),
            life: 3000
          });
        }
      });
    },
    async deleteRole() {
      try {
        if (this.$route.params.role !== 'NEW') {
          await this.rolesStore.deleteRole(this.$route.params.role);
          this.$emit('on-delete');
        }
        this.$router.push({name: 'admin.users.roles', params: {...this.$route.params, role: undefined}});
      } catch (error) {
        console.log(error);
      }
    },
  },
  watch: {
    '$route.params.role': {
      async handler(newValue, oldValue) {
        if (newValue) {
          if (this.$route.params.role === 'NEW') {
            this.roleForm = await this.rolesStore.createRole();
          } else {
            this.roleForm = await this.rolesStore.editRole(this.$route.params.role);
            this.roleForm.id = this.$route.params.role;
          }
        } else {
          this.roleForm = undefined;
        }
      },
      immediate: true,
    }
  },
}
</script>